import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectLoggedIn } from "../../store/slices/auth/slice.js";

const ProtectedRoute = ({ children }) => {
  const loggedIn = useSelector(selectLoggedIn);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    if (loggedIn === false) {
      navigate("/");
      // setTimeout(() => {
      //   dispatch(setSignUpModalOpen(true));
      // }, 300);
    }
  }, [loggedIn, navigate, dispatch]);

  if (loggedIn === false) {
    return null;
  }

  return children;
};

export default ProtectedRoute;
